import { useMemo } from "react";
import { parseFactReferences, renderFactSegments } from "@/lib/factReferences";

/**
 * Reusable component that parses [FACT-xxx] references in text
 * and renders them as clickable FactPopover badges.
 *
 * Usage: <FactText text="Some text [FACT-abc123] here" />
 *
 * Use this component EVERYWHERE text may contain fact references
 * to ensure consistent rendering across the entire app.
 */
export function FactText({ text, factIds }: { text: string; factIds?: string[] }) {
  const { segments } = useMemo(
    () => parseFactReferences(text, factIds),
    [text, factIds]
  );
  return <>{renderFactSegments(segments)}</>;
}
